import moment from "moment";

export const duration = (date1, date2, forEffective = false) => {
    /** 
     * Calcula la duracion de un rental/tour
     * 
     * params:
     *  date1 => date => fecha de inicio del rental/tour
     *  date2 => date => fecha de finalizacion del rental/tour
     *  forEffective => bool => flag para verificar si se van a calcular fechas efectivas
     * 
     * returns:
     *  days => int => duracion total del rental/tour
    */
    let days = moment.utc(date2).diff(date1, "days");//eliminamos el dia que se agrega
    if(forEffective){
        days += 1
    }
    return days || 0;
};


// WEBPACK FOOTER //
// ./src/util/duration.js